var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
var REFRESH_BUFFER_MS = 5 * 60 * 1000;
var TokenExpirationHandler = function (_a) {
    var apiTokenRequest = _a.apiTokenRequest;
    var _b = useMsal(), instance = _b.instance, accounts = _b.accounts;
    var refreshTimerRef = useRef(null);
    useEffect(function () {
        if (accounts.length === 0) {
            return;
        }
        var account = accounts[0];
        var clearRedirectTimer = function () {
            if (refreshTimerRef.current) {
                clearTimeout(refreshTimerRef.current);
                refreshTimerRef.current = null;
            }
        };
        var scheduleRefresh = function (expiresOn) {
            clearRedirectTimer();
            var now = Date.now();
            var timeUntilRefresh = expiresOn.getTime() - now - REFRESH_BUFFER_MS;
            if (timeUntilRefresh <= 0) {
                void refreshToken(true);
                return;
            }
            refreshTimerRef.current = setTimeout(function () {
                void refreshToken(true);
            }, timeUntilRefresh);
        };
        var refreshToken = function (forceRefresh) { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1, redirectError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 7]);
                        return [4 /*yield*/, instance.acquireTokenSilent(__assign(__assign({}, apiTokenRequest), { account: account, forceRefresh: forceRefresh }))];
                    case 1:
                        response = _a.sent();
                        if (response.expiresOn) {
                            scheduleRefresh(response.expiresOn);
                        }
                        else {
                            console.warn('[TokenExpirationHandler] Token response had no expiration');
                        }
                        return [3 /*break*/, 7];
                    case 2:
                        error_1 = _a.sent();
                        console.error('[TokenExpirationHandler] Silent token acquisition failed:', error_1);
                        if (!forceRefresh) return [3 /*break*/, 6];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, instance.acquireTokenRedirect(__assign(__assign({}, apiTokenRequest), { account: account }))];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        redirectError_1 = _a.sent();
                        console.error('[TokenExpirationHandler] Interactive authentication failed:', redirectError_1);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        var initTimer = setTimeout(function () {
            void refreshToken(false);
        }, 500);
        var handleVisibilityChange = function () {
            if (document.visibilityState === 'visible') {
                void refreshToken(false);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            clearTimeout(initTimer);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearRedirectTimer();
        };
    }, [instance, accounts, apiTokenRequest]);
    return null;
};
export default TokenExpirationHandler;
